import request from '@/utils/request'

export function upload(data) { // 图片文件上传
  // 用户档案附件  user_profile
  // 用户头像    users_avatar
  // 文章附件 article_annex
  // 意见反馈附件 user_suggestion
  // 题库  questions
  // 产品相关图片 product_file
  // 趣味视频 interesting_vidio
  // app上传位置 app_file
  return request({
    url: '/admin/upload_pictures',
    method: 'post',
    data: data
  })
}

/* export function getInfo(token) {
  return request({
    url: '/admin/auth/user_info',
    method: 'get'
  //  params: { token }
  })
}

export function logout() {
  return request({
    url: '/admin/auth/sign_out',
    method: 'get'
  })
}
 */



// WEBPACK FOOTER //
// ./src/api/public.js